import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { HeartCrack } from 'lucide-react';
const painPoints = ['Sienten que ya no se entienden como antes, como si hablaran idiomas distintos.', 'Las discusiones se repiten en un bucle infinito y nunca se resuelven de verdad.', 'Hay una distancia emocional silenciosa, aunque vivan bajo el mismo techo.', 'Uno siente que da mucho más que el otro, acumulando resentimiento.', 'Sienten que la chispa se está apagando, pero no saben cómo reavivarla sin forzarlo.'];
export function ProblemSection() {
  return <Section background="secondary" data-id="element-163">
      <div className="text-center mb-16" data-id="element-164">
        <span className="text-accent font-bold tracking-widest uppercase text-sm mb-3 block" data-id="element-165">
          La realidad del amor moderno
        </span>
        <h2 className="font-serif text-3xl md:text-4xl text-white mb-6" data-id="element-166">
          ¿Te reconocés en alguna de estas situaciones?
        </h2>
        <div className="w-16 h-1 bg-accent mx-auto rounded-full" data-id="element-167" />
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.98
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto mb-12 rounded-xl overflow-hidden border border-navy-border relative" data-id="element-168">
        <img src="https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=800&q=80" alt="Pareja distante" className="w-full h-48 md:h-64 object-cover object-center" data-id="element-169" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-800 via-transparent to-transparent" data-id="element-170" />
      </motion.div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-171">
        {painPoints.map((point, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-navy-700 border border-navy-border p-6 rounded-xl flex items-start gap-4" data-id="element-172">
            <div className="mt-1 min-w-[24px] text-accent" data-id="element-173">
              <HeartCrack size={24} strokeWidth={1.5} data-id="element-174" />
            </div>
            <p className="text-lg text-gray-200 leading-relaxed" data-id="element-175">{point}</p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.5
    }} className="mt-16 text-center" data-id="element-176">
        <p className="text-xl md:text-2xl font-serif text-white italic border-l-4 border-accent pl-6 inline-block max-w-2xl text-left" data-id="element-177">
          "El amor no muere por falta de sentimiento, muere por falta de
          herramientas para sostenerlo cuando la etapa del enamoramiento
          termina."
        </p>
      </motion.div>
    </Section>;
}